export const IconPlantTag = (props) => (
    <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 48 48"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
    >
        <path d="M6 4 h36 a3 3 0 0 1 3 3 v11 a3 3 0 0 1 -3 3 H29 l-2 4 v14 l-3 6 -3-6 V25 l-2-4 H6 a3 3 0 0 1 -3-3 V7 a3 3 0 0 1 3-3 Z" />
    </svg>
);
